import { Link } from 'react-router-dom';
import heroBg from '../../../assets/hero-bg.jpg';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={heroBg}
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#070B14] via-[#070B14]/85 to-[#070B14]/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#070B14] via-transparent to-[#070B14]/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-16">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-6">
            <span className="w-6 h-px bg-[#3B82F6]"></span>
            <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
              Software Development
            </span>
          </div>

          <h1 className="font-display text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-[1.1] tracking-tight mb-6 text-balance">
            High-Standard
            <br />
            <span className="text-[#3B82F6]">Software</span>
            <br />
            Development
          </h1>

          <p className="text-slate-300 text-lg lg:text-xl leading-relaxed mb-8 max-w-lg">
            We build reliable, scalable software that solves real business challenges.
            From analysis to delivery – your long-term technology partner.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#3B82F6] hover:bg-[#2563EB] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Get a Free Consultation
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 text-white font-semibold px-7 py-3.5 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Our Services
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-slate-500 text-xs uppercase tracking-widest">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-slate-500 to-transparent"></div>
      </div>
    </section>
  );
}
